const React = require("react");
const Helmet = require("react-helmet").default;

const formatSeoTitle = seo => {
  let title = seo.tags.filter(item => {
    return item.tagName === "title";
  })[0];
  if (!title) return seo;
  title.content = title.content.replace("| Mini Heroes", " | Mini Heroes");
  return seo;
};

const DatoHelmet = ({ seo, favicon, children }) => {
  seo = formatSeoTitle(seo);

  return React.createElement(
    Helmet,
    null,
    (seo ? seo.tags : [])
      .concat(favicon ? favicon.tags : [])
      .map((item, i) =>
        React.createElement(
          item.tagName,
          Object.assign(
            { key: i },
            Object.entries(item.attributes || {}).reduce(
              (acc, [name, value]) => {
                if (value) {
                  acc[name] = value;
                }
                return acc;
              },
              {}
            )
          ),
          item.content
        )
      )
      .concat(children ? children : [])
  );
};

module.exports = { DatoHelmet };



// WEBPACK FOOTER //
// ./src/components/DatoHelmet.js